
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
  const pxToRem = (px: number): string => `${px / 16}rem`;

  return {
    title: {
      maxWidth: 636,
      textAlign: 'center',
      margin: `0 auto ${pxToRem(22)} !important`,
    },
    informationSpinnerContainer: {
      position: 'relative',
      width: '100%',
      height: pxToRem(500),
    },
  };
});

export default useStyles;
